import { getAuditLogEntry } from '@gonfalon/openapi/operations/getAuditLogEntry';
import {
  postAuditLogEntries,
  type PostAuditLogEntriesQueryParams,
  type PostAuditLogEntriesRequestBody,
} from '@gonfalon/openapi/operations/postAuditLogEntries';
import { postAuditLogEntryCounts } from '@gonfalon/openapi/operations/postAuditLogEntryCounts';
import { createQueryKeys } from '@lukemorales/query-key-factory';

import { createInfiniteQueryOptions } from '../internal/createInfiniteQueryOptions';
import { createQueryOptions } from '../internal/createQueryOptions';
import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';

/**
 * @deprecated Use `createQueryOptions` with the OpenAPI operation directly instead.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export const auditLog = createQueryKeys('audit-log', {
  list: ({ spec, params }: { spec: PostAuditLogEntriesRequestBody; params?: PostAuditLogEntriesQueryParams }) => ({
    queryKey: params ? ['entries', spec, params] : ['entries', spec],
    queryFn: async () => reactQueryResponseAdapter(postAuditLogEntries({ body: spec, query: params })),
  }),
  detail: ({ id }: { id: string }) => ({
    queryKey: [id],
    queryFn: async ({ signal }) => reactQueryResponseAdapter(getAuditLogEntry({ id }, { signal })),
  }),
});

export const auditLogEntriesInfiniteQuery = createInfiniteQueryOptions(postAuditLogEntries);

export const postAuditLogEntriesQuery = createQueryOptions(postAuditLogEntries);

export const auditLogEntryQuery = createQueryOptions(getAuditLogEntry);

export const auditLogCountsQuery = createQueryOptions(postAuditLogEntryCounts);
